import React from "react";
import {calcResource, lgSetup} from "../../backend/LgSetup";
import {MDBBtn, MDBCard, MDBCardBody, MDBCardImage, MDBCardText, MDBCardTitle} from "mdb-react-ui-kit";

export function LrrhHome() {
    return (
        <div>
            {Object.keys(lgSetup.circles["LRRH"].lms).map((lmKey) => {
                let lm = lgSetup.lms[lmKey]
                let adKey = ""
                Object.keys(lgSetup.circles["LRRH"].lms[lmKey]).map((addKey1) => {
                    adKey = addKey1
                }
                )
                let banner = calcResource(undefined, lm["bannerResource"])
                let url = "/lgstart" +
                    "?utm_source=lg" +
                    "&utm_campaign=LRRH.C1.INVOLVEMENT.LRRH" +
                    "&utm_medium=COLD.ANY.RU.LRRH.S1-TestAud" +
                    "&utm_content=" + adKey +
                    "&action=START"
                return (
                    <MDBCard className='mb-3' key = {lmKey}>
                        <MDBCardImage position='top' src={banner} alt='...'/>
                        <MDBCardBody>
                            <MDBCardTitle><a href={url}>{lm.desc}</a></MDBCardTitle>
                            <MDBCardText>{lm["motivation"]}
                            </MDBCardText>
                            <MDBCardText>
                                <small className='text-muted'>Last updated 3 mins ago</small>
                            </MDBCardText>
                        </MDBCardBody>
                    </MDBCard>
                )
            })
            }
        </div>
    );
}

